export default "__VITE_ASSET__DXapnOPa__"